export enum DiscountSourceType {
    None = 0,
    SpecialPrice = 1,
    PriceTier = 2,
    Promotions = 3,
    Manual = 4,
    Other = 5
}